import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { laborHoursConstant } from 'src/redux/actions/constant';
import laborHoursService from 'src/services/apiServices/laborHoursService/laborHoursService';

function* getLaborEntryHistory(action: any): SagaReturnType<any> {
  // Every row keys its own slice of state, so the id rides along on each action —
  // expanding several rows at once must not let one response clobber another.
  const labourManagementId = action?.payload?.labourManagementId;
  try {
    yield put({
      type: laborHoursConstant.GET_LABOR_ENTRY_HISTORY_LOADER,
      payload: { labourManagementId },
    });
    const response = yield call(laborHoursService.getLaborEntryHistory, action.payload);
    if (response?.status === 200) {
      yield put({
        type: laborHoursConstant.GET_LABOR_ENTRY_HISTORY_SUCCESS,
        payload: { labourManagementId, data: response.data },
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({
      type: laborHoursConstant.GET_LABOR_ENTRY_HISTORY_FAILURE,
      payload: { labourManagementId, error },
    });
  }
}

function* getLaborEntryHistorySaga() {
  // takeEvery — each expanded row is an independent fetch, keyed by its own id.
  yield takeEvery(laborHoursConstant.GET_LABOR_ENTRY_HISTORY_REQUEST, getLaborEntryHistory);
}

export default getLaborEntryHistorySaga;
